import React, { useState } from 'react';
import { Modal, Button, Form, Badge, Row, Col } from 'react-bootstrap';

/* ----- quick helpers ------------------------------------------------- */
const todayISO = () => new Date().toISOString().slice(0, 10);

const defaultSapMeta = {
  periodKeyword: 'yesterday',
  fromDate: '',
  toDate:   '',
  companyIds:   ''
};

const defaultBankMeta = {
  periodKeyword: 'yesterday',
  fromDate: '',
  toDate:   '',
  companyId:  '',
  accountNumber: ''
};

/* --------------------------------------------------------------------- */
const TaskConfigModal = ({ show, onHide, onNext }) => {
  const [taskType, setTaskType] = useState('SAP Extraction'); // or Bank Statement
  const [sapMeta,  setSapMeta]  = useState(defaultSapMeta);
  const [bankMeta, setBankMeta] = useState(defaultBankMeta);

  const commonPeriods = ['yesterday', 'lastWeek', 'lastMonth', 'lastYear', 'custom'];

  /* ----- handlers ----------------------------------------------------- */
  const handleNext = () => {
    const meta = taskType === 'SAP Extraction' ? sapMeta : bankMeta;
    onNext({ taskType, parameters: JSON.stringify(meta) });
  };

  /* ----- render helpers ---------------------------------------------- */
  const renderPeriodRow = (meta, setMeta) => (
    <>
      <Form.Label className="fw-bold">Period</Form.Label>
      <div className="d-flex gap-2 flex-wrap">
        {commonPeriods.slice(0, -1).map(pk => (
          <Badge
            key={pk}
            pill
            bg={meta.periodKeyword === pk ? 'primary' : 'secondary'}
            style={{ cursor: 'pointer' }}
            onClick={() => setMeta({ ...meta, periodKeyword: pk, fromDate: '', toDate: '' })}
          >
            {pk}
          </Badge>
        ))}
        <Badge
          pill
          bg={meta.periodKeyword === 'custom' ? 'primary' : 'secondary'}
          style={{ cursor: 'pointer' }}
          onClick={() => setMeta({ ...meta, periodKeyword: 'custom' })}
        >
          custom
        </Badge>
      </div>

      {meta.periodKeyword === 'custom' && (
        <Row className="mt-2">
          <Col>
            <Form.Control type="date" value={meta.fromDate}
              onChange={e => setMeta({ ...meta, fromDate: e.target.value })}
              max={todayISO()} />
          </Col>
          <Col>
            <Form.Control type="date" value={meta.toDate}
              onChange={e => setMeta({ ...meta, toDate: e.target.value })}
              max={todayISO()} />
          </Col>
        </Row>
      )}
    </>
  );

  const renderSapForm = () => (
    <>
      {renderPeriodRow(sapMeta, setSapMeta)}

      <Form.Group className="mt-3">
        <Form.Label>Company IDs <small>(comma-sep or blank = all)</small></Form.Label>
        <Form.Control
          placeholder="1,2,3"
          value={sapMeta.companyIds}
          onChange={e => setSapMeta({ ...sapMeta, companyIds: e.target.value })}
        />
      </Form.Group>
    </>
  );

  const renderBankForm = () => (
    <>
      {renderPeriodRow(bankMeta, setBankMeta)}

      <Row className="mt-3">
        <Col>
          <Form.Group>
            <Form.Label>Company ID</Form.Label>
            <Form.Control
              value={bankMeta.companyId}
              onChange={e => setBankMeta({ ...bankMeta, companyId: e.target.value })}
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>Account number <small>(empty = all)</small></Form.Label>
            <Form.Control
              value={bankMeta.accountNumber}
              onChange={e => setBankMeta({ ...bankMeta, accountNumber: e.target.value })}
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  );

  /* ----- main render -------------------------------------------------- */
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Configure Task</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label className="fw-bold">Task type</Form.Label>
          <Form.Select
            value={taskType}
            onChange={e => setTaskType(e.target.value)}
          >
            <option>SAP Extraction</option>
            <option>Bank Statement</option>
          </Form.Select>
        </Form.Group>

        {taskType === 'SAP Extraction' ? renderSapForm() : renderBankForm()}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="primary" onClick={handleNext}>Next</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TaskConfigModal;
